import IntegrationTable from '@/components/shared/IntegrationTable/IntegrationTable';
import SmsFunnelIcon from '../icons/Sms';
import { integrationFieldPresets } from '@/components/shared/IntegrationTable/integrationFieldPresets';
import MundSmsFunnel from '../icons/MundSmsFunnel';
import { paymentStatus } from '@/utils/paymentMethods';

export default function SmsFunnel() {
  return (
    <IntegrationTable
      integrationKey='sms_funnel'
      title='SMS Funnel'
      main_icon={<MundSmsFunnel />}
      icon={<SmsFunnelIcon />}
      fields={[
        integrationFieldPresets.postback_url,
        integrationFieldPresets.status,
      ]}
      fixedOptions={{
        active_statuses: [...paymentStatus, 'abandoned_cart'],
      }}
    />
  );
}
